export const EVENTO_LEITURA_NOVIDADES = "sear:novidades:leitura";

// Somente identificadores de publicações; a leitura fica neste navegador.
export function chaveLeituraNovidades(userId, role) {
  return userId !== null && userId !== undefined && String(userId).trim()
    ? `sear:novidades:v1:${role}:${userId}` : null;
}

export function lerNovidadesVistas(chave) {
  if (!chave) return [];
  try {
    const valor = JSON.parse(localStorage.getItem(chave) || "[]");
    return Array.isArray(valor) ? [...new Set(valor.filter(id => typeof id === "string"))] : [];
  } catch { return []; }
}

export function salvarNovidadesVistas(chave, ids) {
  if (!chave) return false;
  const unicos = [...new Set(ids)];
  let salvo = false;
  try { localStorage.setItem(chave, JSON.stringify(unicos)); salvo = true; }
  catch { /* Mantém o destaque sincronizado nesta sessão. */ }
  window.dispatchEvent(new CustomEvent(EVENTO_LEITURA_NOVIDADES, { detail: { chave, ids: unicos } }));
  return salvo;
}
